import { cx } from "@jugl-web/utils";
import { FC } from "react";
import { ReactComponent as ChevronIcon } from "./assets/chevron.svg";

interface ProductVariantSelectProps {
  label: string;
  options: {
    id: string;
    label: string;
    isDisabled: boolean;
  }[];
  selectedOption: string | null;
  onSelect: (option: string) => void;
}

export const ProductVariantSelect: FC<ProductVariantSelectProps> = ({
  label,
  options,
  selectedOption,
  onSelect,
}) => {
  const hasSelectedOption = selectedOption !== null;

  return (
    <div className="flex flex-col gap-1">
      <span className="font-secondary text-dark-700 px-2 text-[13px] font-normal leading-[140%]">
        {label}:
      </span>
      <div className="border-grey-300 hover:bg-grey-100 relative flex h-[42px] items-center overflow-hidden rounded-[10px] border border-solid bg-white transition-colors">
        <select
          value={selectedOption ?? ""}
          onChange={(e) => onSelect(e.target.value)}
          className={cx(
            "font-secondary h-full w-full appearance-none border-0 bg-transparent pl-4 pr-10 text-sm leading-[160%] outline-none",
            hasSelectedOption
              ? "text-dark font-medium"
              : "text-dark-600 font-normal"
          )}
        >
          {!hasSelectedOption && (
            <option value="" disabled>
              Select
            </option>
          )}
          {options.map((option) => (
            <option
              key={option.id}
              value={option.id}
              disabled={option.isDisabled}
            >
              {option.label}
            </option>
          ))}
        </select>
        <ChevronIcon className="pointer-events-none absolute right-3" />
      </div>
    </div>
  );
};
